import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Carica promo locali dell'host + promo Hostland Pro, normalizzate con lat/lng
// (estratte dal link Google Maps lato backend) per i pin sulla mappa sconti.
export function useGuestPromos(propertyId, lang = "it") {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    Promise.all([
      axios.get(`${API}/promos/public/${propertyId}?lang=${lang}`)
        .then((r) => (r.data.promos || []).map((p) => ({ ...p, isPro: false })))
        .catch(() => []),
      axios.get(`${API}/pro/public/${propertyId}?lang=${lang}`)
        .then((r) => (r.data.promos || []).map((p) => ({
          promo_id: p.promo_id, source: "local", isPro: true, pill: p.pill, category: p.category,
          service_icon: p.logo_url, service_name: p.business_name, service_desc: p.business_desc,
          promo_desc: p.promo_desc, promo_type: p.activation_type, url: p.link_url, code: p.code_text,
          maps_url: p.gmaps_url, lat: p.lat, lng: p.lng,
        })))
        .catch(() => []),
    ])
      .then(([base, pro]) => { if (alive) setPromos([...base, ...pro]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [propertyId, lang]);

  return { promos, loading };
}
